export enum SupportedLanguage {
  EN = 'en',
  DE = 'de',
  PT = 'pt',
}

export enum supportLangCountry {
  deDE = 'de-DE',
  enUS = 'en-US',
  ptPT = 'pt-PT',
}

export enum I18N_KEYS {
  NAVIGATION = 'navigation',
  ASSET_LAYER_BUILDING_LABEL = 'asset_layer_label_d_building',
  ASSET_LAYER_AREA_LABEL = 'asset_layer_label_d_area',
  NEW_BUILDING_PLACEHOLDER = 'new_building_placeholder',
  NEW_AREA_PLACEHOLDER = 'new_Area_placeholder',
  YES_DELETE_SENSOR = 'yes_delete_sensor',
  YES_DELETE_EQUIPMENT = 'yes_delete_equipment',
  DELETE_PLANT = 'delete_plant',
  DELETE_AREA = 'delete_area',
  DELETE_BUILDING = 'delete_building',
  DELETE_SENSOR = 'delete_sensor',
  DELETE_FLOOR = 'delete_floor',
  DELETE_SECTION = 'delete_section',
  DELETE_ZONE = 'delete_zone',
  DELETE_SCROSSING = 'delete_scrossing',
  DELETE_ASSOCIATEDEQ = 'delete_associatedeq',
  DELETE_EQUIPMENT = 'delete_equipment',
  HOW_WILL_THE_PHOTO_LOOK = 'how_will_the_photo_look',
  FLANGE = 'flange',
  PIPE = 'pipe',
  STEAMTRAP = 'steamtrap',
  ROTATING = 'rotatingEqu',
  CENTRIFUGE = 'centrifuge',
  COMPRESSOR = 'compressor',
  MOTOR = 'electronical_motor',
  FANS_BLOWERS = 'fans_and_blowers',
  GEAR_DRIVERS = 'gear_drivers',
  PUMP = 'pump',
  ROTATING_OTHER = 'rotating_other',
  EM_IA_BOTH = 'EM_IA_both',
  EM_ONLY = 'EM_Only',
  WHERE_IS_QR_CODE = 'where_is_qr_code',
  SENSOR_QR_INSTRUCTION_1 = 'sensor_qr_instruction_1',
  SENSOR_QR_INSTRUCTION_2 = 'sensor_qr_instruction_2',
  JUNCTION_BOX_POPUP_TITLE = 'junction_box_popup_title',
  // JUNCTION_BOX_INSTRUCTIONS = 'junction_box_popup_instructions',
  JUNCTION_BOX_POPUP_INSTRUCTIONS = 'junction_box_popup_instructions',
  SENSOR_QR_INSTRUCTION_3 = 'sensor_qr_instruction_3',
  INLET_GATEWAY = 'inlet_gateway',
  INLET_DAU = 'inlet_dau',
  INLET_SENSOR_HEADER = 'inlet_sensor_header',
  OUTLET_GATEWAY = 'outlet_gateway',
  OUTLET_DAU = 'outlet_dau',
  OUTLET_SENSOR_HEADER = 'outlet_sensor_header',
  CONNECT = 'connect',
  PHOTO = 'photo',
  LOCATION = 'location',
  CONTINUE = 'continue',
  GATEWAY = 'gateway',
  INLET = 'inlet',
  OUTLET = 'outlet',
  DAU = 'DAU',
  ULTRASONIC = 'Ultrasonic',
  CONNECTION_CAPACITY_GATEWAY_POPUP_TITLE = 'connection_capacity_gateway_popup_title',
  MATRIX_CODE_LOCATION = 'matrix_code_location',
  WHERE_IS_THE_MATRIX_CODE = 'where_is_the_matrix_code',
  CONNECTION_ERROR_POPUP_TITLE = 'connection_error_popup_title',
  CONNECTION_ERROR_POPUP_INSTRUCTION1 = 'connection_error_popup_instructions1',
  CONNECTION_ERROR_POPUP_INSTRUCTION2 = 'connection_error_popup_instructions2',
  CONNECTION_ERROR_POPUP_INSTRUCTION3 = 'connection_error_popup_instructions3',
  CONNECTION_ERROR_POPUP_INSTRUCTION4 = 'connection_error_popup_instructions4',
  FINISH_SENSOR = 'finish_sensor',
  PROFILE = 'profile',
  CHANGEPASSWORD = 'change_password',
  LANGUAGE = 'language',
  MEASUREMENTSYSTEM = 'measurement_system',
  APPEARANCE = 'appearance',
  NOTIFICATIONS = 'notifications',
  TECHNICALDOCFLANGE = 'technical_documents_smart_flange',
  TECHNICALDOCSTEAMTRAP = 'technical_documents_steamtrap',
  TECHNICALDOCROTATING = 'technical_documents_rotatingequipment',
  TECHNICALDOC = 'technical_documents',
  HELPANDSUPPORT = 'help_and_support',
  IMPRINT = 'imprint',
  IMPRINT2 = 'imprint2',
  TERMSOFUSE = 'terms_of_use',
  DATAPROTECTION = 'data_protection_declaration',
  SERVICECONDITIONS = 'service_conditions',
  NOTEFORUSRESIDENTS = 'note_for_us_residents',
  SYSTEM_MAINTENANCE = 'system_maintenance',
  MAINTENANCE_MESSAGE = 'maintenance_message',
  SYSTEM_OUTAGE = 'system_outage',
  OUTAGE_MESSAGE = 'outage_message',
  ASSET_LAYER_LABEL = 'asset_layer_label_',
  SERVICE_PROVIDER_TITLE = 'service_provider_title',
  SERVICE_PROVIDER = 'service_provider',
  REGISTERED_OFFICE_TITLE = 'registerd_office_title',
  REGISTERED_OFFICE = 'registerd_office',
  POSTAL_ADDRESS_TITLE = 'postal_adress_title',
  POSTAL_ADDRESS = 'postal_adress',
  COMMERCIAL_REGISTERD_TITLE = 'commercial_register_title',
  COMMERCIAL_REGISTER = 'commercial_register',
  VAT_ID_NO_TITLE = 'vat_id_no_title',
  VAT_ID_NO = 'vat_id_no',
  EMAIL_CONTACT_TITLE = 'email_contact_title',
  EMAIL_CONTACT = 'email_contact',
  INLET_SENSOR_QR_INS = 'inlet_sensor_qr_instruction',
  INLET_SENSOR_QR_INS_STEP1 = 'inlet_sensor_qr_instruction_step1',
  INLET_SENSOR_QR_INS_STEP2 = 'inlet_sensor_qr_instruction_step2',
  INLET_SENSOR_QR_INS_STEP3 = 'inlet_sensor_qr_instruction_step3',
  TAKE_OR_UPLOAD_PHOTO = 'take_or_upload_photo',
  TAKE_PHOTO = 'take_photo',
  UPLOAD_PHOTO = 'upload_photo',
  SENSOR_QR_INS_DAU = 'sensor_qr_instruction_DAU',
  GATEWAY_HTST = 'gateway_htst',
  MAC_ADDRESS = 'Mac_address',
  DAU_MODEL = 'dau_model',
  SENSOR_COLOR = 'sensor_color',
  OVERVIEW = 'overview',
  BEFORE_START = 'before_you_start',
  VERIFY_APPLICATION = 'verify_application',
  REPAIR_PROCESS = 'repair_process',
  PLAN_THE_PROCESS = 'plan_the_process',
  ACCESSIBILITY_REPAIR_AREA = 'accessibility_repair_area',
  REQUIRED_TOOLS = 'required_tools',
  ENVIRONMENT_CONDITION = 'environment_condition',
  OPERATION_MANUAL = 'refer_to_operation_manual',
  SENSOR_INSTRUCTION_CNT1 = 'sensor_instruction_content1',
  SENSOR_INSTRUCTION_CNT2 = 'sensor_instruction_content2',
  SENSOR_INSTRUCTION_CNT3 = 'sensor_instruction_content3',
  SENSOR_INSTRUCTION_CNT4 = 'sensor_instruction_content4',
  SENSOR_INSTRUCTION_CNT5 = 'sensor_instruction_content5',
  SENSOR_INSTRUCTION_CNT6 = 'sensor_instruction_content6',
  SENSOR_INSTRUCTION_CNT7 = 'sensor_instruction_content7',
  SENSOR_INSTRUCTION_CNT8 = 'sensor_instruction_content8',
  SENSOR_INSTRUCTION_CNT9 = 'sensor_instruction_content9',
  SENSOR_INSTRUCTION_CNT10 = 'sensor_instruction_content10',
  SENSOR_INSTRUCTION_CNT11 = 'sensor_instruction_content11',
}

export enum FormKey {
  // Control Names
  Name = 'name',
  Surname = 'surname',
  Email = 'email',
  Username = 'username',
  CaptchaResponse = 'captchaResponse',
  Password = 'password',
  Captcha = 'captcha',
  CurrentPassword = 'currentPassword',
  ConfirmPassword = 'confirmPassword',
  Title = 'title',
  Country = 'country',
  CustomerEntity = 'customerentity',
  Customer = 'customer',
  Access = 'access',
  Checkbox = 'checkbox',
  Text = 'text',
  // PasswordType = 'password',
  Select = 'select',
  Radio = 'radio',
  Designation = 'designation',
  SelectCountry = 'select_country',
  SelectCustomer = 'select_customer',
  UserHasAccessTo = 'user_has_access_to',
  PwValidation6 = 'pw_validation6',
  LabelEmail = 'Email',
  LabelCurrentPassword = 'current_password',
  LabelNewPassword = 'new_password_1',
  LabelRepeatPassword = 'repeat_password',
  EmailPlaceholder = 'name@example.com',
  PasswordMask = '*********',
  InitialUser = 'user',
  Empty = '',
  MinLength3 = 3,
}

export enum I18n_keys {
  GATEWAY_HTST = 'gateway_htst',
  MAC_ADDRESS = 'Mac_address',
  DAU_MODEL = 'dau_model',
  SENSOR_COLOR = 'sensor_color',
  OVERVIEW = 'overview',
  BEFORE_START = 'before_you_start',
  VERIFY_APPLICATION = 'verify_application',
  REPAIR_PROCESS = 'repair_process',
  PLAN_THE_PROCESS = 'plan_the_process',
  ACCESSIBILITY_REPAIR_AREA = 'accessibility_repair_area',
  REQUIRED_TOOLS = 'required_tools',
  ENVIRONMENT_CONDITION = 'environment_condition',
  OPERATION_MANUAL = 'refer_to_operation_manual',
  SENSOR_INSTRUCTION_CNT1 = 'sensor_instruction_content1',
  SENSOR_INSTRUCTION_CNT2 = 'sensor_instruction_content2',
  SENSOR_INSTRUCTION_CNT3 = 'sensor_instruction_content3',
  SENSOR_INSTRUCTION_CNT4 = 'sensor_instruction_content4',
  SENSOR_INSTRUCTION_CNT5 = 'sensor_instruction_content5',
  SENSOR_INSTRUCTION_CNT6 = 'sensor_instruction_content6',
  SENSOR_INSTRUCTION_CNT7 = 'sensor_instruction_content7',
  SENSOR_INSTRUCTION_CNT8 = 'sensor_instruction_content8',
  SENSOR_INSTRUCTION_CNT9 = 'sensor_instruction_content9',
  SENSOR_INSTRUCTION_CNT10 = 'sensor_instruction_content10',
  SENSOR_INSTRUCTION_CNT11 = 'sensor_instruction_content11',
  BATTERY = 'Battery',
  BATTERIE = 'Batterie',
  HOME = 'home',
}
